import type { JarvisState } from "../types";

interface OrbProps {
  state: JarvisState;
}

const TICK_COUNT = 72;

function TickRing() {
  const ticks = Array.from({ length: TICK_COUNT }, (_, i) => {
    const angle = (360 / TICK_COUNT) * i;
    const major = i % 6 === 0;
    return (
      <line
        key={i}
        x1="128"
        y1={major ? "6" : "12"}
        x2="128"
        y2="20"
        transform={`rotate(${angle} 128 128)`}
        strokeWidth={major ? 2 : 1}
      />
    );
  });
  return (
    <g className="orb-ticks" stroke="currentColor">
      {ticks}
    </g>
  );
}

export function Orb({ state }: OrbProps) {
  return (
    <div className={`orb-wrapper state-${state}`} aria-hidden="true">
      <svg className="orb-svg" viewBox="0 0 256 256">
        <g transform="translate(128 128)">
          <g transform="translate(-128 -128)">
            <circle className="orb-ring-outer" cx="128" cy="128" r="124" />
            <circle className="orb-ring-tick-base" cx="128" cy="128" r="108" />
            <g className="orb-tick-group">
              <TickRing />
            </g>
            <circle className="orb-ring-inner" cx="128" cy="128" r="92" />
            <circle className="orb-sweep" cx="128" cy="128" r="100" />
          </g>
        </g>
      </svg>

      <div className="orb-glow" />

      <div className="orb-particles">
        <div className="particle-orbit orbit-1">
          <span className="particle-dot" />
        </div>
        <div className="particle-orbit orbit-2">
          <span className="particle-dot" />
        </div>
        <div className="particle-orbit orbit-3">
          <span className="particle-dot" />
        </div>
      </div>

      <div className="orb-core-wrap">
        <div className="orb-core" />
        <div className="orb-core-highlight" />
      </div>
    </div>
  );
}
